import React from 'react';
import { Box, Typography } from '@mui/material';
import { appColors } from '../../Config/Theme';

interface StackedMiniKpiProps {
  topLabel: string;
  topValue: number | string;
  bottomLabel: string;
  bottomValue: number | string;
  onTopClick?: () => void;
  onBottomClick?: () => void;
}

const StackedMiniKpi: React.FC<StackedMiniKpiProps> = ({
  topLabel,
  topValue,
  bottomLabel,
  bottomValue,
  onTopClick,
  onBottomClick,
}) => {
  const boxSx = (clickable: boolean) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: 1.5,
    py: 1,
    borderRadius: '8px',
    bgcolor: appColors.surface.card,
    border: `1px solid ${appColors.border.default}`,
    cursor: clickable ? 'pointer' : 'default',
    '&:hover': clickable ? { borderColor: appColors.primary.main, bgcolor: `${appColors.primary.main}08` } : {},
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
      <Box sx={boxSx(!!onTopClick)} onClick={onTopClick} role={onTopClick ? 'button' : undefined}>
        <Typography variant="body2" sx={{ fontWeight: 600, color: appColors.text.body }}>
          {topLabel}
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 700, color: appColors.text.heading }}>
          {topValue}
        </Typography>
      </Box>
      <Box sx={boxSx(!!onBottomClick)} onClick={onBottomClick} role={onBottomClick ? 'button' : undefined}>
        <Typography variant="body2" sx={{ fontWeight: 600, color: appColors.text.body }}>
          {bottomLabel}
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 700, color: appColors.text.heading }}>
          {bottomValue}
        </Typography>
      </Box>
    </Box>
  );
};

export default StackedMiniKpi;
